<div class="orders-history-detail">
  <div class="aligner">
    <div class="row m-0 detail-body">
      <div class="col-6 first-block">
        <div class="first-line">
          <div class="first-line-info">
            <div class="id">ID: &nbsp;
              <b>{{dataOrder.orderID}}</b>
            </div>
            <div class="estrategiaValidade">
              <div class="div-space">Operação:
                <b>{{ showStrategieOrder ? dataOrder?.orderStrategy : '-'}}</b>
              </div>
              <div>Validade:
                <b>{{ orderValidity }}</b>
              </div>
            </div>
            <div class="vertical-divider"></div>
            <div class="qtdAparenteMinima">
              <div class="div-space">Qtd Aparente:
                <b>{{dataOrder.maxFloor ? dataOrder.maxFloor : '-'}}</b>
              </div>
              <div class="div-space">Qtd Mínima:
                <b>{{dataOrder.minQty ? dataOrder.minQty : '-'}}</b>
              </div>
            </div>
          </div>
          <div class="first-line-rotulo">
            <b>Rótulo:</b> &nbsp;{{dataOrder.orderTag}}
          </div>
        </div>
        <div class="second-line" [ngClass]="{'display-none': !showTypeStopOrder}">
          <div class="half-content" *ngIf="!showTypeStopOrder">
            <div class="preco">Preço:
              <b>&nbsp;{{futureIndice || dataOrder.price === '' ? '' : dataOrder.price ? 'R$ ' : '-'}}
                {{dataOrder.price === '' ? '-' : dataOrder.price | number}}</b>
            </div>
          </div>
          <div class="half-content" *ngIf="showTypeStopOrder">
            <div class="preco">P. de disp. de ganho:
              <b>&nbsp;{{futureIndice || dataOrder.priceStopGain === '' ? '' : dataOrder.priceStopGain ? 'R$ ' : '-'}}
                {{dataOrder.priceStopGain === '' ? '-' : dataOrder.priceStopGain | number}}</b>
            </div>
            <div class="preco">P. de disp. de perda:
              <b>&nbsp;{{futureIndice || dataOrder.priceStop === '' ? '' : dataOrder.priceStop ? 'R$ ' : '-'}}
                {{dataOrder.priceStop === '' ? '-' : dataOrder.priceStop | number}}</b>
            </div>
          </div>
          <div class="half-content" *ngIf="showTypeStopOrder">
            <div class="preco">P. de limite de ganho:
              <b>&nbsp;{{futureIndice || dataOrder.price2 === '' ? '' : dataOrder.price2 ? 'R$ ' : '-'}}
                {{dataOrder.price2 === '' ? '-' : dataOrder.price2 | number}}</b>
            </div>
            <div class="preco">P. de limite de perda:
              <b>&nbsp;{{futureIndice || dataOrder.price === '' ? '' : dataOrder.price ? 'R$ ' : '-'}}
                {{dataOrder.price === '' ? '-' : dataOrder.price | number}}</b>
            </div>
          </div>
        </div>
        <div class="third-line">
          <b>Motivo da rejeição:&nbsp;</b> {{dataOrder.text}}
        </div>
      </div>
      <div class="col-6 second-block">
        <div class="blue-text">
          Histórico de Atualizações
        </div>
        <div class="tableDiv">
          <app-spinner-loading *ngIf='loading'></app-spinner-loading>
          <table class="col-12 table table-striped table-sm" *ngIf="!loading">
            <tr>
              <th class="letter-align">Status</th>
              <th>Qtd.</th>
              <th>Pr. Oferta</th>
              <th>Execuções</th>
              <th>Data e Hora</th>
            </tr>
            <tr *ngFor="let item of listHistoryOrder">
              <td class="letter-align">{{ item.state }}</td>
              <td>{{ item.quantityExecuted }} / {{ item.quantitySupplied }}</td>
              <td>{{ item.price }}</td>
              <td>{{ item.quantityExecuted ? item.quantityExecuted + ' @ ' + item.price : '' }}</td>
              <td>{{ item.transactTime ? (item.transactTime | date: 'dd/MM/yyyy HH:mm:ss') : item.transactTime }}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
